import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const TestimonialsSection = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = [
    {
      name: 'Sarah Johnson',
      location: 'Austin, TX',
      vehicle: '2019 Honda Civic',
      saleAmount: '$18,500',
      rating: 5,
      text: 'I couldn\'t believe how easy it was! I got my offer in just 3 hours and had the money in my account the same day. No dealership visits, no haggling - just a fair price and professional service.',
      avatar: 'S'
    },
    {
      name: 'Michael Chen', 
      location: 'Seattle, WA',
      vehicle: '2020 Toyota Camry',
      saleAmount: '$24,200',
      rating: 5,
      text: 'The process was incredibly smooth. The inspector was professional, the offer was competitive, and I received payment within hours. I\'ve recommended iSell.car to all my friends.',
      avatar: 'M'
    },
    {
      name: 'Emily Rodriguez',
      location: 'Miami, FL', 
      vehicle: '2018 Ford Explorer',
      saleAmount: '$21,800',
      rating: 5,
      text: 'Best car selling experience ever! I was skeptical at first, but they delivered on every promise. Got $3,000 more than the dealership offered me. Highly recommend!',
      avatar: 'E'
    },
    {
      name: 'David Thompson',
      location: 'Denver, CO',
      vehicle: '2021 Subaru Outback', 
      saleAmount: '$27,900',
      rating: 5,
      text: 'Amazing service from start to finish. The whole process took less than 4 hours from upload to payment. The team was responsive and transparent throughout.',
      avatar: 'D'
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Join thousands of satisfied customers who've sold their cars quickly and easily with iSell.car
          </p>
        </div>

        {/* Main Testimonial Display */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12 border border-border">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
              {/* Customer Info */}
              <div className="text-center lg:text-left">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full text-white text-2xl font-bold mb-4">
                  {testimonials[activeTestimonial].avatar}
                </div>
                <h3 className="text-xl font-bold text-foreground mb-1">
                  {testimonials[activeTestimonial].name}
                </h3>
                <p className="text-sm text-muted-foreground mb-2">
                  {testimonials[activeTestimonial].location}
                </p>
                <div className="flex items-center justify-center lg:justify-start space-x-1 mb-3">
                  {[...Array(testimonials[activeTestimonial].rating)].map((_, i) => (
                    <Icon key={i} name="Star" size={16} className="text-yellow-400 fill-current" />
                  ))}
                </div>
                <div className="inline-flex items-center space-x-2 bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                  <Icon name="DollarSign" size={14} />
                  <span>{testimonials[activeTestimonial].saleAmount}</span>
                </div>
              </div>

              {/* Testimonial Content */}
              <div className="lg:col-span-2">
                <blockquote className="text-lg lg:text-xl text-foreground leading-relaxed italic mb-4">
                  "{testimonials[activeTestimonial].text}"
                </blockquote>
                <div className="text-sm text-muted-foreground">
                  <span className="font-medium">Vehicle sold:</span> {testimonials[activeTestimonial].vehicle}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonial Navigation */}
        <div className="flex justify-center space-x-4 mb-8">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setActiveTestimonial(index)}
              className={`w-12 h-12 rounded-full border-2 transition-all duration-300 ${
                index === activeTestimonial
                  ? 'border-blue-500 bg-blue-500 text-white' :'border-gray-300 bg-white text-gray-600 hover:border-blue-300'
              }`}
            >
              {testimonials[index].avatar}
            </button>
          ))}
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="text-center bg-white rounded-xl p-6 border border-border">
            <div className="text-2xl lg:text-3xl font-bold text-blue-600 mb-2">50K+</div>
            <div className="text-sm text-muted-foreground">Cars Sold</div>
          </div>
          <div className="text-center bg-white rounded-xl p-6 border border-border">
            <div className="text-2xl lg:text-3xl font-bold text-green-600 mb-2">4.9★</div>
            <div className="text-sm text-muted-foreground">Average Rating</div>
          </div>
          <div className="text-center bg-white rounded-xl p-6 border border-border">
            <div className="text-2xl lg:text-3xl font-bold text-purple-600 mb-2">24hrs</div>
            <div className="text-sm text-muted-foreground">Average Offer Time</div>
          </div>
          <div className="text-center bg-white rounded-xl p-6 border border-border">
            <div className="text-2xl lg:text-3xl font-bold text-orange-600 mb-2">98%</div>
            <div className="text-sm text-muted-foreground">Customer Satisfaction</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;